import '@ver-uds/styles';

import { EverifyUserRole, MyI9TrainingStatus, User } from '@vis-auth/vis-user-client';

import { EveHeader } from '@ver-uds/e-verify';
import React from 'react';
import ReactGA from 'react-ga4';
import { useLogout } from '@vis-auth/react';
import { useAccount } from '../../context/Account/AccountContext';
import { useEnvironment } from '../../context/Environment/EnvironmentContext';
import Environment from '../../constants/Environment';
import { useUser } from '../../context/User/UserContext';
import { GetAuthServiceMFA } from '../../utils/mfaAuthUtils';

const Header = (): JSX.Element => {
  const { roles, firstName, lastName, myI9TrainingStatus, tutorialComplete, mfaEnabled } = useUser() as User;
  const { type, webServiceAccess, myI9 } = useAccount();

  const evePlusTrainingComplete =
    myI9TrainingStatus === MyI9TrainingStatus.COMPLETE || myI9TrainingStatus === MyI9TrainingStatus.OVERRIDDEN;
  const evePlusEnabled = myI9?.enabled ?? false;

  // Determines if the eve+ training link is shown
  const showTrainingLink: boolean = evePlusTrainingComplete && evePlusEnabled;

  // Hide nav items if tutorial is incomplete or if eve+ training has not been completed
  const hideNavItems = !tutorialComplete || (evePlusEnabled && !evePlusTrainingComplete);

  // MFA - mfa user logout
  const authService = GetAuthServiceMFA();
  const useMFALogout = () => {
    try {
      authService.mfaLogoutRedirect();
    } catch (error) {
      throw new Error(`Error within header: ${error}`);
    }
  };

  const handleMFALogout = mfaEnabled ? () => useMFALogout : useLogout;

  const { ENVIRONMENT_NAME } = useEnvironment();
  const enableSelfTestLink = [
    Environment.LOCAL,
    Environment.DEVTEST,
    Environment.SYSTEST,
    Environment.EXTERNALTEST,
  ].includes(ENVIRONMENT_NAME);

  if (!ReactGA.isInitialized) {
    ReactGA.initialize(ENVIRONMENT_NAME === Environment.PROD ? 'G-HXH7SL0ZYG' : 'G-KRTN40GWV3', {
      // eslint-disable-next-line @typescript-eslint/camelcase
      gtagOptions: { send_page_view: false },
    });
  }

  return (
    <EveHeader
      user={{ firstName: firstName || '', lastName: lastName || '', roles: roles as EverifyUserRole[], mfaEnabled }}
      account={{ accountType: type, webServiceAccess: webServiceAccess.enabled }}
      showSelfTestLink={enableSelfTestLink}
      onLogOut={handleMFALogout}
      showTrainingLink={showTrainingLink}
      hideNavItems={hideNavItems}
    />
  );
};

export default Header;
